import { useTranslation } from 'react-i18next'

import { Button, Modal } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const BankAccountBlackListModal = ({ show, onClose, onAccept }) => {
  const { t } = useTranslation()
  return (
    <Modal show={show} onClose={onClose} title={t('Reembolso instantáneo no disponible')} size="m" blockOnClose>
      <Styles.Container>
        <h1>{t('¡Lo sentimos!')}</h1>
        <p>
          {t(
            'No podemos ofrecerte la opción de reembolso instantáneo, por favor completa el proceso de devolución con tu método de pago original.'
          )}
        </p>
        <Button onClick={onAccept}>{t('Solicitar reembolso en el método de pago original')}</Button>
      </Styles.Container>
    </Modal>
  )
}

export default BankAccountBlackListModal
